<div class="row">
  <div class="col-12">
    <div class="card">

      <!-- Header -->
      <div class="card-header filter" *ngIf="header">
        <span class="filterspan">{{ header }}</span>
      </div>

      <!-- Body -->
      <div class="card-body">
        <div class="row g-3 align-items-center">

          <!-- ================= LEFT SIDE FILTERS ================= -->
          <div class="col-12 col-xl-9">
            <div class="row g-3">

              <ng-container *ngIf="!consumer">
                <!-- 1. LOCKED SITE -->
                <div class="col-12 col-sm-6 col-md-4 col-lg-3" *ngIf="shouldShowLockedSite">
                  <button class="btn btn-light text-dark w-100 h-100 d-flex align-items-center justify-content-between"
                    type="button" disabled>
                    <span>{{ lockedSiteName }}</span>
                  </button>
                </div>

                <!-- 2. DATE AND FLAT FILTER DAILY REPORT -->
                <div class="col-12 col-sm-6 col-md-4 col-lg-3" *ngIf="showDateFlatToggle">
                  <div class="input-group">
                    <select class="form-select" [(ngModel)]="selectedfiltersType"
                      (ngModelChange)="DailyReportHandler()">
                      <option *ngFor="let items of DateFlatArray" [value]="items.value">
                        {{ items.value }}
                      </option>
                    </select>
                  </div>
                </div>

                <!-- 3. SINGLE SITE SELECT (SEARCHABLE) -->
                <div class="col-12 col-sm-6 col-md-4 col-lg-3" *ngIf="shouldShowSingleSiteSelect">
                  <div ngbDropdown class="w-100">
                    <button class="btn dropdown-toggle w-100 d-flex justify-content-between align-items-center"
                      ngbDropdownToggle>
                      <span>{{ selectedSite?.site_name || 'Select Site' }}</span>
                    </button>

                    <ul class="dropdown-menu dropdown-block" ngbDropdownMenu
                      style="min-width: 250px; max-height: 300px; overflow-y: auto;">

                      <li class="px-1 py-1 sticky-top bg-white search-container">
                        <img src="assets/DashboardIcon/searchicon.svg" alt="searchicon"
                          style="position: absolute;right: 7px;top: 7px;">
                        <input type="text" class="form-control form-control-sm searchbar" placeholder="Search Sites..."
                          [(ngModel)]="searchTerm" (click)="handleItemClick($event)" aria-label="Search sites">
                      </li>
                      <li>
                        <hr class="dropdown-divider mt-1 mb-0">
                      </li>

                      <cdk-virtual-scroll-viewport appendOnly itemSize="20" style="height: 250px; width: 100%;">

                        <!-- SHIMMER STATE -->
                        <ng-container *ngIf="siteloading; else siteListTpl">
                          <li class="list" *ngFor="let _ of shimmerArray">
                            <div class="dropdown-item px-2 py-1 shimmer-item">
                              <div class="shimmer-text w-100" style="height:14px;"></div>
                            </div>
                          </li>
                        </ng-container>

                        <!-- REAL DATA -->
                        <ng-template #siteListTpl>
                          <li class="list" *ngFor="let item of filteredItems">
                            <a class="dropdown-item px-2 py-1" href="javascript:void(0)" (click)="selectSite(item)">
                              {{ item.site_name }}
                            </a>
                          </li>

                          <li *ngIf="shouldShowNoSitesFound()" class="px-3 py-2 text-muted text-center">
                            No sites found.
                          </li>

                          <li *ngIf="shouldShowNoSitesAvailable()" class="px-3 py-2 text-muted text-center">
                            No sites available.
                          </li>
                        </ng-template>

                      </cdk-virtual-scroll-viewport>
                    </ul>
                  </div>
                </div>

                <!-- 4. SITE MULTI SELECT (CHECKBOX LIST) -->
                <div class="col-12 col-sm-6 col-md-4 col-lg-3" *ngIf="shouldShowMultiSiteSelect">
                  <div class="w-100" ngbDropdown [autoClose]="'outside'" style="height:40px">
                    <button
                      class="btn text-dark dropdown-toggle d-flex justify-content-between align-items-center w-100"
                      type="button" ngbDropdownToggle>
                      <span>{{ getSelectedSiteNames() }}</span>
                      <span *ngIf="selectedItemsCount > 0" class="badge bg-primary counter ms-2">{{ selectedItemsCount
                        }}</span>
                    </button>

                    <ul class="dropdown-menu dropdown-block" ngbDropdownMenu
                      style="min-width: 250px; max-height: 300px; overflow-y: auto;">

                      <li class="px-1 py-1 sticky-top bg-white search-container">
                        <img src="assets/DashboardIcon/searchicon.svg" alt="searchicon"
                          style="position: absolute;right: 7px;top: 7px;">
                        <input type="text" class="form-control form-control-sm searchbar" placeholder="Search Sites..."
                          [(ngModel)]="searchTerm" (click)="handleItemClick($event)" aria-label="Search sites">
                      </li>
                      <li>
                        <hr class="dropdown-divider mt-1 mb-0">
                      </li>

                      <!-- SHIMMER STATE -->
                      <ng-container *ngIf="siteloading; else siteItemsTpl">
                        <li class="list" *ngFor="let _ of shimmerArray">
                          <div class="dropdown-item d-flex align-items-center px-2 py-1 shimmer-item">
                            <div class="shimmer-text me-2" style="width:16px;height:16px;border-radius:3px;"></div>
                            <div class="shimmer-text flex-grow-1" style="height:14px;"></div>
                          </div>
                        </li>
                      </ng-container>

                      <!-- REAL ITEMS -->
                      <ng-template #siteItemsTpl>
                        <li class="list" *ngFor="let item of filteredItems; let i = index">
                          <a class="dropdown-item d-flex align-items-center px-2 py-1" href="javascript:void(0)"
                            (click)="handleItemClick($event)">
                            <input type="checkbox" class="form-check-input me-2" [id]="'item-' + item.site_id"
                              [(ngModel)]="item.selected" (ngModelChange)="onItemSelectionChange(item)"
                              (click)="$event.stopPropagation()" />
                            <label [for]="'item-' + item.site_id" class="form-check-label flex-grow-1">
                              {{ item.site_name }}
                            </label>
                          </a>
                        </li>

                        <li *ngIf="shouldShowNoSitesFound()" class="px-3 py-2 text-muted text-center">
                          No sites found.
                        </li>
                        <li *ngIf="shouldShowNoSitesAvailable()" class="px-3 py-2 text-muted text-center">
                          No sites available.
                        </li>
                      </ng-template>

                    </ul>
                  </div>
                </div>

                <!-- TOWER SELECT (SEARCHABLE) -->
                <div class="col-12 col-sm-6 col-md-4 col-lg-3" *ngIf="isTowerSelect">
                  <div ngbDropdown class="w-100">
                    <button class="btn dropdown-toggle w-100 d-flex justify-content-between align-items-center"
                      ngbDropdownToggle>
                      <span>{{ selectedTower?.name || 'Select Tower' }}</span>
                    </button>

                    <ul class="dropdown-menu dropdown-block" ngbDropdownMenu
                      style="min-width: 250px; max-height: 300px; overflow-y: auto;">

                      <li class="px-1 py-1 sticky-top bg-white search-container">
                        <img src="assets/DashboardIcon/searchicon.svg" alt="searchicon"
                          style="position: absolute; right: 7px; top: 7px;">
                        <input type="text" class="form-control form-control-sm searchbar" placeholder="Search Tower..."
                          [(ngModel)]="towerSearchTerm" (click)="$event.stopPropagation()">
                      </li>
                      <li>
                        <hr class="dropdown-divider mt-1 mb-0">
                      </li>

                      <cdk-virtual-scroll-viewport appendOnly itemSize="20" style="height: 250px; width: 100%;">
                        <li class="list" *ngFor="let tower of filteredTowers">
                          <a class="dropdown-item px-2 py-1" href="javascript:void(0)" (click)="selectTower(tower)">
                            {{ tower.name }}
                          </a>
                        </li>

                        <li *ngIf="filteredTowers.length === 0" class="px-3 py-2 text-muted text-center">
                          No Towers found.
                        </li>
                      </cdk-virtual-scroll-viewport>
                    </ul>
                  </div>
                </div>

                <!-- 5. LOCATION FROM (SEARCHABLE) -->
                <div class="col-12 col-sm-6 col-md-4 col-lg-3" *ngIf="shouldShowFromToLocation">
                  <div ngbDropdown class="w-100">
                    <button class="btn dropdown-toggle w-100 d-flex justify-content-between align-items-center"
                      ngbDropdownToggle>
                      <span>{{ selectedLocationFrom?.location_no || 'From Unit' }}</span>
                    </button>

                    <ul class="dropdown-menu dropdown-block" ngbDropdownMenu
                      style="min-width: 250px; max-height: 300px; overflow-y: auto;">

                      <li class="px-1 py-1 sticky-top bg-white search-container">
                        <img src="assets/DashboardIcon/searchicon.svg" alt="searchicon"
                          style="position: absolute; right: 7px; top: 7px;">
                        <input type="text" class="form-control form-control-sm searchbar" placeholder="Search Unit..."
                          [(ngModel)]="locationSearchTermFrom" (click)="$event.stopPropagation()">
                      </li>
                      <li>
                        <hr class="dropdown-divider mt-1 mb-0">
                      </li>

                      <cdk-virtual-scroll-viewport appendOnly itemSize="20" style="height: 250px; width: 100%;">
                        <li class="list" *ngFor="let location of filteredLocationsFrom">
                          <a class="dropdown-item px-2 py-1" href="javascript:void(0)"
                            (click)="onlocationSelectFrom(location)">
                            {{ location.location_no }}
                          </a>
                        </li>

                        <li *ngIf="filteredLocationsFrom.length === 0" class="px-3 py-2 text-muted text-center">
                          No Units found.
                        </li>
                      </cdk-virtual-scroll-viewport>
                    </ul>
                  </div>
                </div>

                <!-- 6. LOCATION TO (SEARCHABLE) -->
                <div class="col-12 col-sm-6 col-md-4 col-lg-3" *ngIf="shouldShowFromToLocation">
                  <div ngbDropdown class="w-100">
                    <button class="btn dropdown-toggle w-100 d-flex justify-content-between align-items-center"
                      ngbDropdownToggle>
                      <span>{{ selectedLocationTo?.location_no || 'To Unit' }}</span>
                    </button>

                    <ul class="dropdown-menu dropdown-block" ngbDropdownMenu
                      style="min-width: 250px; max-height: 300px; overflow-y: auto;">

                      <li class="px-1 py-1 sticky-top bg-white search-container">
                        <img src="assets/DashboardIcon/searchicon.svg" alt="searchicon"
                          style="position: absolute; right: 7px; top: 7px;">
                        <input type="text" class="form-control form-control-sm searchbar" placeholder="Search Unit..."
                          [(ngModel)]="locationSearchTermTo" (click)="$event.stopPropagation()">
                      </li>
                      <li>
                        <hr class="dropdown-divider mt-1 mb-0">
                      </li>

                      <cdk-virtual-scroll-viewport appendOnly itemSize="20" style="height: 250px; width: 100%;">
                        <li class="list" *ngFor="let location of filteredLocationsTo">
                          <a class="dropdown-item px-2 py-1" href="javascript:void(0)"
                            (click)="onlocationSelectTo(location)">
                            {{ location.location_no }}
                          </a>
                        </li>

                        <li *ngIf="filteredLocationsTo.length === 0" class="px-3 py-2 text-muted text-center">
                          No Units found.
                        </li>
                      </cdk-virtual-scroll-viewport>
                    </ul>
                  </div>
                </div>

                <!-- 7. LOCATION SINGLE (SEARCHABLE) -->
                <div class="col-12 col-sm-6 col-md-4 col-lg-3" *ngIf="shouldShowSingleLocation">
                  <div ngbDropdown class="w-100">
                    <button class="btn dropdown-toggle w-100 d-flex justify-content-between align-items-center"
                      ngbDropdownToggle>
                      <span>{{ selectedLocation?.location_no || 'Unit' }}</span>
                    </button>

                    <ul class="dropdown-menu dropdown-block" ngbDropdownMenu
                      style="min-width: 250px; max-height: 300px; overflow-y: auto;">

                      <li class="px-1 py-1 sticky-top bg-white search-container">
                        <img src="assets/DashboardIcon/searchicon.svg" alt="searchicon"
                          style="position: absolute; right: 7px; top: 7px;">
                        <input type="text" class="form-control form-control-sm searchbar" placeholder="Search Unit..."
                          [(ngModel)]="locationSearchTerm" (click)="$event.stopPropagation()">
                      </li>
                      <li>
                        <hr class="dropdown-divider mt-1 mb-0">
                      </li>

                      <cdk-virtual-scroll-viewport appendOnly itemSize="20" style="height: 250px; width: 100%;">
                        <li class="list" *ngFor="let location of filteredLocations">
                          <a class="dropdown-item px-2 py-1" href="javascript:void(0)"
                            (click)="onlocationSelectsingle(location)">
                            {{ location.location_no }}
                          </a>
                        </li>

                        <li *ngIf="filteredLocations.length === 0" class="px-3 py-2 text-muted text-center">
                          No Units found.
                        </li>
                      </cdk-virtual-scroll-viewport>
                    </ul>
                  </div>
                </div>

                <!-- 8. APPLIANCES (SEARCHABLE) -->
                <div class="col-12 col-sm-6 col-md-4 col-lg-3" *ngIf="showappliances">
                  <div ngbDropdown class="w-100">
                    <button class="btn dropdown-toggle w-100 d-flex justify-content-between align-items-center"
                      ngbDropdownToggle>
                      <span>{{ selectedItemAppliance || 'Select Appliance' }}</span>
                    </button>
                    <ul class="dropdown-menu dropdown-block" ngbDropdownMenu
                      style="min-width: 250px; max-height: 300px; overflow-y: auto;">
                      <li class="list" *ngFor="let app of selectedAppliances">
                        <a class="dropdown-item px-2 py-1" href="javascript:void(0)" (click)="OnApplianceSelect(app)">
                          {{ app.name }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <!-- 9. DATE RANGE PICKER -->
                <div class="col-12 col-sm-6 col-md-4 col-lg-3" *ngIf="shouldShowDateRangePicker">
                  <div class="date-range-wrapper w-100">
                    <input class="form-control datepicker" #rangePicker="mwlFlatpickr" placeholder="From - To"
                      mwlFlatpickr [disableMobile]="true" [minDate]="minDate" [maxDate]="today" [mode]="'range'" [(ngModel)]="dateRange"
                      (ngModelChange)="updateFormattedDates()">
                    <img class="calendar-icon" src="assets/DashboardIcon/calendar-icon.svg"
                      (click)="openCalendarIndividual(rangePicker)">
                  </div>
                </div>

                <!-- 10. SINGLE DATE / MONTH-YEAR PICKER -->
                <div class="col-12 col-sm-6 col-md-4 col-lg-3" *ngIf="shouldShowSingleDatePicker">
                  <div class="date-range-wrapper w-100">
                    <input class="form-control datepicker" #singlePicker="mwlFlatpickr" type="text"
                      [placeholder]="Month_Year ? 'Select Month' : 'Select Date'" mwlFlatpickr [disableMobile]="true"
                      [plugins]="Month_Year ? monthPlugins : []" [minDate]="minDate" [maxDate]="today" [mode]="'single'"
                      [(ngModel)]="selectedDate" (ngModelChange)="updateFormattedDate()" />
                    <img src="assets/DashboardIcon/calendar-icon.svg"
                      class="calendar-icon position-absolute end-0 top-50 translate-middle-y me-2" alt="calendar"
                      (click)="openCalendarIndividual(singlePicker)">
                  </div>
                </div>

                <!-- 11. MONTH RANGE PICKER -->
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 d-flex" *ngIf="Month_Range" style="gap: 3px;">
                  <div class="col-12 col-sm-6 col-md-6 col-lg-6 h-100" style="padding: 0px 1px;">
                    <div class="date-range-wrapper w-100 h-100">
                      <input mwlFlatpickr #fromMonthPicker="mwlFlatpickr" class="form-control datepicker"
                        placeholder="From Month" style="height: 100%;" [minDate]="minDate" [maxDate]="today" [disableMobile]="true"
                        [plugins]="monthPlugins" [(ngModel)]="fromDateTime"
                        (ngModelChange)="updateFormattedMonthRange()" />
                      <img class="calendar-icon" src="assets/DashboardIcon/calendar-icon.svg"
                        (click)="openCalendarIndividual(fromMonthPicker)">
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-6 h-100" style="padding: 0px 1px;">
                    <div class="date-range-wrapper w-100 h-100">
                      <input class="form-control datepicker" placeholder="To Month" #toMonthPicker="mwlFlatpickr"
                        style="height: 100%;" mwlFlatpickr [disableMobile]="true" [minDate]="minDate" [maxDate]="today"
                        [plugins]="monthPlugins" [(ngModel)]="toDateTime" (ngModelChange)="updateFormattedMonthRange()">
                      <img class="calendar-icon" src="assets/DashboardIcon/calendar-icon.svg"
                        (click)="openCalendarIndividual(toMonthPicker)">
                    </div>
                  </div>
                </div>

                <!-- 12. DATE AND TIME FROM TO -->
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 d-flex" *ngIf="showDateTimeRangePicker"
                  style="gap: 3px;">
                  <div class="col-12 col-sm-6 col-md-6 col-lg-6 h-100" style="padding: 0px 1px;">
                    <div class="date-range-wrapper w-100 h-100">
                      <input mwlFlatpickr #fromPicker="mwlFlatpickr" class="form-control datepicker"
                        placeholder="From Date & Time" style="height: 100%;" [minDate]="minDate" [maxDate]="today" [disableMobile]="true"
                        [enableTime]="true" [enableSeconds]="true" [time24hr]="true" [dateFormat]="'Y-m-d H:i:S'"
                        [(ngModel)]="fromDateTime" (ngModelChange)="updateFormattedDatesTime()" />
                      <img class="calendar-icon" src="assets/DashboardIcon/calendar-icon.svg"
                        (click)="openCalendarIndividual(fromPicker)">
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-6 h-100" style="padding: 0px 1px;">
                    <div class="date-range-wrapper w-100 h-100">
                      <input class="form-control datepicker" placeholder="To Date & Time" #ToPicker="mwlFlatpickr"
                        style="height: 100%;" mwlFlatpickr [disableMobile]="true" [minDate]="minDate" [maxDate]="today" [enableTime]="true"
                        [enableSeconds]="true" [time24hr]="true" [dateFormat]="'Y-m-d H:i:S'" [defaultHour]="23"
                        [defaultMinute]="59" [defaultSeconds]="59" [(ngModel)]="toDateTime"
                        (ngModelChange)="updateFormattedDatesTime()">
                      <img class="calendar-icon" src="assets/DashboardIcon/calendar-icon.svg"
                        (click)="openCalendarIndividual(ToPicker)">
                    </div>
                  </div>
                </div>

                <!-- 13. HOURS -->
                <div *ngIf="Hours" class="col-12 col-sm-6 col-md-4 col-lg-3">
                  <div ngbDropdown class="w-100">
                    <button class="btn dropdown-toggle w-100 d-flex justify-content-between align-items-center"
                      ngbDropdownToggle>
                      <span>{{ selectedHours || 'Select Hour' }}</span>
                    </button>
                    <ul class="dropdown-menu dropdown-block" ngbDropdownMenu
                      style="min-width: 250px; max-height: 300px; overflow-y: auto;">
                      <li class="list" *ngFor="let h of hours">
                        <a class="dropdown-item px-2 py-1" href="javascript:void(0)" (click)="selecthour(h)">{{ h }}</a>
                      </li>
                    </ul>
                  </div>
                </div>

                <!-- 14. GENERIC DROPDOWN -->
                <div *ngIf="dropdown" class="col-12 col-sm-6 col-md-4 col-lg-3">
                  <div ngbDropdown class="w-100">
                    <button class="btn dropdown-toggle w-100 d-flex justify-content-between align-items-center"
                      ngbDropdownToggle>
                      <span class="d-flex align-items-center gap-2">
                        <img *ngIf="selectedDropdown?.icon || selectedDropdown?.image"
                          [src]="selectedDropdown?.icon || selectedDropdown?.image" alt=""
                          style="height: 18px; width: 18px; object-fit: contain;">
                        {{ selectedDropdown?.name || placeholder }}
                      </span>
                    </button>
                    <ul class="dropdown-menu dropdown-block" ngbDropdownMenu
                      style="min-width: 250px; max-height: 300px; overflow-y: auto;">
                      <li class="list" *ngFor="let h of dropdownList">
                        <a class="dropdown-item px-2 py-1 d-flex align-items-center gap-2" href="javascript:void(0)"
                          (click)="Selected(h)">
                          <img *ngIf="h?.icon || h?.image" [src]="h?.icon || h?.image" alt=""
                            style="height: 18px; width: 18px; object-fit: contain;">
                          {{ h?.name }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <!-- 15. SUBTYPE -->
                <div class="col-12 col-sm-6 col-md-4 col-lg-3" *ngIf="showsubtype">
                  <div class="btn-group w-100" ngbDropdown>
                    <button
                      class="btn w-100 {{ subtype.class }} dropdown-toggle d-flex align-items-center justify-content-between"
                      type="button" ngbDropdownToggle style="padding: 9px 10px 8px 10px !important;">
                      <span class="d-flex align-items-center gap-2">
                        <img *ngIf="getSelectedSubtypeIcon()" [src]="getSelectedSubtypeIcon()" alt=""
                          style="height: 18px; width: 18px; object-fit: contain;">
                        {{ selectedItem || subtype.title }}
                      </span>
                    </button>
                    <ul class="dropdown-menu dropdown-block" ngbDropdownMenu>
                      @for (item of subtype.item; track item) {
                      <li>
                        <a class="dropdown-item d-flex align-items-center gap-2" href="javascript:void(0)"
                          ngbDropdownItem (click)="onDropdownItemSelect(item)">
                          <img *ngIf="item.icon || item.image" [src]="item.icon || item.image" alt=""
                            style="height: 18px; width: 18px; object-fit: contain;">
                          {{ item.name }}
                        </a>
                      </li>
                      }
                    </ul>
                  </div>
                </div>

                <!-- 16. BILL NO -->
                <div class="col-12 col-sm-6 col-md-4 col-lg-3" *ngIf="showBillNo">
                  <div class="btn-group w-100" ngbDropdown>
                    <button class="btn w-100 {{ Billingno.class }} dropdown-toggle" type="button" ngbDropdownToggle
                      style="padding: 9px 10px 8px 10px !important;">
                      {{ BillingItem || Billingno.title }}
                    </button>
                    <ul class="dropdown-menu dropdown-block" ngbDropdownMenu>
                      @for (item of Billingno.item; track item) {
                      <li>
                        <a class="dropdown-item" href="javascript:void(0)" ngbDropdownItem (click)="BillingNo(item)">
                          {{ item.name }}
                        </a>
                      </li>
                      }
                    </ul>
                  </div>
                </div>

                <!-- 17. SEARCH INPUT -->
                <div *ngIf="search" class="col-12 col-sm-6 col-md-4 col-lg-3">
                  <input type="text" class="form-control w-100 h-100" autocomplete="one-time-code" autocorrect="off"
                    autocapitalize="off" spellcheck="false" data-lpignore="true" data-1p-ignore="true" data-bwignore="true" data-form-type="other"
                    [name]="'filter_search_' + (header || 'input')"
                    [placeholder]="placeholder || (selectedItem ? 'Search by ' + selectedItem + ' ID/Name' : 'Search...')"
                    [(ngModel)]="searchText" />
                </div>

                <!-- 18. DYNAMIC FILTERS (filterConfig) -->
                <ng-container *ngIf="filterConfig?.length">
                  <div [class]="field.col || 'col-12 col-sm-6 col-md-4 col-lg-3'"
                    *ngFor="let field of filterConfig; let fieldIdx = index">

                    <!-- Dynamic Text Input -->
                    <input *ngIf="field.type === 'text'" type="text" class="form-control" autocomplete="one-time-code" autocorrect="off"
                      autocapitalize="off" spellcheck="false" data-lpignore="true" data-1p-ignore="true" data-bwignore="true"
                      data-form-type="other" [name]="'dyn_text_' + (field.apiKey || field.key || fieldIdx)"
                      [(ngModel)]="field.value" [placeholder]="field.placeholder || field.label || ''">

                    <!-- Dynamic Searchable Dropdown -->
                    <div *ngIf="field.type === 'select'" ngbDropdown class="w-100">
                      <button type="button"
                        class="btn dropdown-toggle w-100 d-flex justify-content-between align-items-center"
                        ngbDropdownToggle>
                        <span>
                          {{ getSelectedOptionLabel(field) || field.placeholder || field.label || 'Select' }}
                        </span>
                      </button>

                      <ul class="dropdown-menu dropdown-block" ngbDropdownMenu
                        style="min-width: 250px; max-height: 300px; overflow-y: auto;">

                        <li class="px-1 py-1 sticky-top bg-white search-container"
                          *ngIf="(field.options?.length || 0) > 5">
                          <img src="assets/DashboardIcon/searchicon.svg" alt="searchicon"
                            style="position: absolute;right: 7px;top: 7px;">
                          <input type="text" class="form-control form-control-sm searchbar" autocomplete="off"
                            autocorrect="off" autocapitalize="off" spellcheck="false" data-lpignore="true"
                            data-form-type="other" [name]="'dyn_search_' + (field.apiKey || field.key || fieldIdx)"
                            [placeholder]="'Search ' + (field.placeholder || field.label || '') + '...'"
                            [(ngModel)]="field.searchTerm" (click)="$event.stopPropagation()"
                            (keydown)="$event.stopPropagation()" [attr.aria-label]="'Search ' + (field.label || '')">
                        </li>

                        <li *ngIf="(field.options?.length || 0) > 5">
                          <hr class="dropdown-divider mt-1 mb-0">
                        </li>

                        <li class="list" *ngFor="let opt of getFilteredDynamicOptions(field)">
                          <a class="dropdown-item px-2 py-1" href="javascript:void(0)" ngbDropdownItem
                            (click)="onSelectDynamicOption(field, opt); $event.preventDefault()">
                            {{ opt.label || opt.name }}
                          </a>
                        </li>

                        <li *ngIf="getFilteredDynamicOptions(field).length === 0"
                          class="px-3 py-2 text-muted text-center">
                          No options found.
                        </li>
                      </ul>
                    </div>

                  </div>
                </ng-container>
              </ng-container>

              <!-- 19. CONSUMER SEARCH -->
              <div class="row g-2 align-items-start" *ngIf="consumer">
                <div class="col-12 col-md-4 col-lg-3">
                  <select id="type" class="form-select" [(ngModel)]="selectedType" (change)="onSelectedTypeChange()">
                    <option value="location_no">Search By Unit No.</option>
                    <option value="mobile_no">Search By Mobile No.</option>
                  </select>
                </div>

                <div class="col-12 col-md-8 col-lg-4" *ngIf="selectedType === 'mobile_no'">
                  <input type="text" class="form-control" [(ngModel)]="locationNo" placeholder="Enter Mobile No.">
                </div>

                <div class="col-12 col-md-8 col-lg-4" *ngIf="selectedType === 'location_no'">
                  <div ngbDropdown class="w-100">
                    <button class="btn dropdown-toggle w-100 d-flex justify-content-between align-items-center"
                      ngbDropdownToggle>
                      {{ locationNo || 'Unit No' }}
                    </button>

                    <ul class="dropdown-menu dropdown-block" ngbDropdownMenu
                      style="min-width: 250px; max-height: 300px; overflow-y: auto;">
                      <li class="px-1 py-1 sticky-top bg-white search-container">
                        <img src="assets/DashboardIcon/searchicon.svg" alt="searchicon"
                          style="position: absolute; right: 7px; top: 7px;">
                        <input type="text" class="form-control form-control-sm searchbar" placeholder="Search Unit..."
                          [(ngModel)]="locationSearchTerm" (click)="$event.stopPropagation()">
                      </li>
                      <li>
                        <hr class="dropdown-divider mt-1 mb-0">
                      </li>

                      <cdk-virtual-scroll-viewport appendOnly itemSize="20" style="height: 250px; width: 100%;">
                        <li class="list" *ngFor="let location of filteredLocations">
                          <a class="dropdown-item px-2 py-1" href="javascript:void(0)"
                            (click)="onlocationSelectsingle(location, 'name')">
                            {{ location.location_no }}
                          </a>
                        </li>
                        <li *ngIf="filteredLocations.length === 0" class="px-3 py-2 text-muted text-center">
                          No Units found.
                        </li>
                      </cdk-virtual-scroll-viewport>
                    </ul>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <!-- ================= RIGHT ACTION BUTTONS ================= -->
          <div class="col-12 col-xl-3">
            <div class="d-flex gap-2 justify-content-xl-end justify-content-start flex-wrap">
              <button type="button" class="btn btn-link text-danger fw-semibold" (click)="resetFilters()">
                Reset
              </button>
              <button type="button" class="btn btn-primary px-4" (click)="applyFilters()">
                Apply
              </button>
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>
</div>